import {Component, inject, OnInit} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {Keyboard} from '@capacitor/keyboard';
import {IonicModule, Platform} from '@ionic/angular';
import {AuthApiService} from './Services/Api/Auth/auth-api.service';
import {SplashScreenManagerService} from './Services/Platform/Capacitor/splash-screen-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonicModule]
})
export class AppComponent implements OnInit {

  private readonly platform = inject(Platform);
  private readonly auth = inject(AuthApiService);
  private readonly splashScreenManager = inject(SplashScreenManagerService);

  ngOnInit() {
    this.platform.ready().then(() => {
      this.splashScreenManager.hide()
      this.auth.syncSentryUser();

      this.initKeyboardEvents();
    });
  }


  /**
   * Inicializar los eventos del teclado
   *
   */
  initKeyboardEvents() {

    if (!Capacitor.isNativePlatform()) {
      return;
    }

    Keyboard.addListener('keyboardWillShow', () => {
      document.body.classList.add('keyboard-open');
    });

    Keyboard.addListener('keyboardWillHide', () => {
      setTimeout(() => document.body.classList.remove('keyboard-open'), 250);
    });

  }

}
